import { APIClient } from '@frontend/api-utils';
import { ProductAvailability } from '@frontend/stock/types';

export class StockAvailabilityClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    public static async postGetProductAvailability(accountId: string, ids: string[], spotId?: string): Promise<ProductAvailability> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/product-availability${spotId ? '?spot_id=' + spotId : ''}`, { ids: ids });
        return await this.handleResponse<ProductAvailability>(response);
    }

    public static async postGetProductCategoryAvailability(accountId: string, ids: string[], spotId?: string): Promise<ProductAvailability> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/product-category-availability${spotId ? '?spot_id=' + spotId : ''}`, {
            ids: ids
        });
        return await this.handleResponse<ProductAvailability>(response);
    }
}
